import LOCALS from 'commons/locals';
import type { FmsRecycleStat, FmsShopCashSettlement } from 'types/fms';

export type RecycleStatHistoryRow = {
  key: string;
  type: number;
  labelKey: string;
  currency: string;
  count: number;
  totalAmount: number;
};

const RECYCLE_STAT_LABEL_KEY_BY_TYPE: Record<number, string> = {
  1: LOCALS.consignment,
  2: LOCALS.recycle,
};

export const buildRecycleStatRows = (
  stats: FmsRecycleStat[] = [],
): RecycleStatHistoryRow[] => {
  const rowMap = stats.reduce<Record<string, RecycleStatHistoryRow>>(
    (result, stat) => {
      const currency = stat.currency || '-';
      const key = `${stat.type}-${currency}`;
      const current = result[key] ?? {
        key,
        type: stat.type,
        labelKey: RECYCLE_STAT_LABEL_KEY_BY_TYPE[stat.type] ?? String(stat.type),
        currency,
        count: 0,
        totalAmount: 0,
      };

      return {
        ...result,
        [key]: {
          ...current,
          count: current.count + Number(stat.count || 0),
          totalAmount: current.totalAmount + Number(stat.totalAmount || 0),
        },
      };
    },
    {},
  );

  return Object.values(rowMap).sort((a, b) => {
    if (a.type !== b.type) return a.type - b.type;
    return a.currency.localeCompare(b.currency);
  });
};

export const hasSettlementDetails = (
  record: FmsShopCashSettlement,
): boolean => {
  const { cashPayments, nonCashPayments, refundPayments } =
    record.paymentDetails ?? {};
  return Boolean(
    cashPayments?.length ||
      nonCashPayments?.length ||
      refundPayments?.length ||
      record.recycleStats?.length,
  );
};
